import React from 'react';
import { Link } from 'react-router-dom';

function TermsPage() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Terms of Use</h1>
      <p className="text-gray-600 mb-4">Last updated: May 2026</p>
      <div className="prose prose-gray space-y-4 text-gray-700">
        <p>
          By using WhoDatNumber you agree to post honest, lawful reports. Do not submit false,
          defamatory, or harassing content. Reports may be published immediately; we may unapprove or remove content at our discretion.
        </p>
        <p>
          Number lookup information is community-sourced and provided &quot;as is&quot; without warranty.
          Verify important information independently before taking action.
        </p>
        <p>
          Verified owners may claim numbers and request privacy settings. Abuse of the claim or
          verification process may result in account suspension.
        </p>
      </div>
      <Link to="/" className="inline-block mt-8 text-blue-600 hover:underline">
        Back to home
      </Link>
    </div>
  );
}

export default TermsPage;

